/**
  报表管理--巡检保养统计
 */
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import ScGridTable from "@/components/display/table/gridTableCore";
import FormCore from "@/components/display/form/formCore";
import { getCityList, getInspectionStatisticsApi } from "../../fetch/fetchApi";
import monthPickerHoc from "../../hoc/form/monthPickerHoc";
import RefreshGrid from "../../utils/refreshGrid";
import { triggerDownloadFiles } from "../../utils/utils";
// 国际化切换语言

@monthPickerHoc
// eslint-disable-next-line arrow-parens
@connect((state) => state)
class inspectionAndMaintenanceStatistics extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubOrderInfo;
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.state = {};
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  componentDidMount() {
    this.fetchApi({
      date: [moment(), moment()],
    });
  }

  // 数据导出
  exportData = async (params) => {
    await triggerDownloadFiles(
      "/mtsV2/ticketType/statistics/export",
      this.parseFormData(params),
      "巡检保养统计",
      "xlsx",
      "post",
    );
  };

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "date",
          dateType: "rangeMonth",
          placeholder: ["年/月", "年/月"],
          width: "200px",
          param: {
            name: "date",
            type: "array",
          },
          defaultValue: [moment(new Date()).startOf("month"), moment(new Date())],
          validator: {
            // 自定义校验对象
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
            max_val: 365, // 可选最大天数
          },
          allowClear: false,
          labelName: "统计区间",
          required: true,
        },
        {
          type: "input",
          placeholder: "请输入电站名称",
          param: {
            name: "stationName",
            type: "string",
          },
          labelName: "电站名称",
          required: false,
        },
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          required: !1,
          labelName: "地区",
          className: "allshow",
          showCheckedStrategy: "SHOW_PARENT",
          treeCheckable: true,
          sourceApi: getCityList,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "reset",
              text: "重置",
              handler: (e, param) => {
              this.fetchApi({
                page: 1,
                pagecount: 10,
                cityId:'',
                stationName:'',
                date: [moment(), moment()],
              })
              },
            },
            {
              btnType: "submit",
              text: "查询",
            },
            {
              btnType: "button",
              text: "导出",
              handler: (e, param) => {
                this.exportData(param);
              },
            },
          ],
        },
      ],
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        type: 1,
      },
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "inspectionAndMaintenanceStatisticsTable",
    };
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: "年份",
            key: "year",
            colType: "textCol",
            align: "center",
          },
          {
            name: "月份",
            key: "month",
            colType: "textCol",
            align: "center",
          },
          {
            name: "电站ID",
            key: "stationId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "电站名称",
            key: "stationName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "省份",
            key: "province",
            colType: "textCol",
            align: "center",
          },
          {
            name: "城市",
            key: "city",
            colType: "textCol",
            align: "center",
          },
          {
            name: "电站巡检次数",
            key: "inspectNumStation",
            colType: "textCol",
            align: "center",
          },
          {
            name: "已完成巡检次数",
            key: "inspectFinishNumStation",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备巡检次数",
            key: "inspectNumTarget",
            colType: "textCol",
            align: "center",
          },
          {
            name: "已完成设备巡检次数",
            key: "inspectFinishNumTarget",
            colType: "textCol",
            align: "center",
          },
          {
            name: "电站保养次数",
            key: "maintenanceNumStation",
            colType: "textCol",
            align: "center",
          },
          {
            name: "已完成电站保养次数",
            key: "maintenanceFinishNumStation",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备保养次数",
            key: "maintenanceNumTarget",
            colType: "textCol",
            align: "center",
          },
          {
            name: "已完成设备保养次数",
            key: "maintenanceFinishNumTarget",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {},
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getInspectionStatisticsApi,
        tableKey: "inspectionAndMaintenanceStatisticsTable",
      },
    });
  }

  parseFormData = (params) => {
    const result = { ...params };
    if (params.date) {
      const [start, end] = params.date;
      result.startDate = start.format("YYYYMM");
      result.endDate = end.format("YYYYMM");
      delete result.date;
    }
    if (params.cityId) {
      result.cityId = params.cityId.join(",");
    }
    return result;
  };

  fetchApi = (params) => {
    // 如果正常页面中的表单提交，请执行下面
    return RefreshGrid(
      this.context.store,
      "inspectionAndMaintenanceStatisticsTable",
      this.parseFormData(params),
    );
  };

  render() {
    return (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel gzsbTable">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );
  }
}

export default injectIntl(inspectionAndMaintenanceStatistics);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/inspectionAndMaintenanceStatistics.js